import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi';
import logo from '../../assets/logo.png';

import './footer.css';

const Footer = () => (
  <div className="app__footer section__padding" id="footer">
   
   

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">Madam Mercy Road Gwagwalada Abuja Nigeria</p>
        <p className="p__opensans">+234 0809Ja</p>

      </div>

      <div className="app__footer-links_logo">
        <img src={logo} alt="footer_logo" />
        <p className="p__opensans">&quot;Time to work less and work more&quot;</p>
       
        <div className="app__footer-links_icons">
          <FiFacebook />
          <FiTwitter />
          <FiInstagram />
        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Working Hours</h1>
        <p className="p__opensans">Monday-Friday:</p>
        <p className="p__opensans">08:00 am - 5:00 pm</p>
       
      </div>
    </div>

    <div className="footer__copyright">
      <p className="p__opensans">2022 Eazi Invest Int. All Rights reserved.</p>
    </div>

  </div>
);

export default Footer;
